export enum THEMES {
  LIGHT = "light",
  DARK = "dark"
}